import React from 'react';

import {
    GROUPING_MONTH,
    GROUPING_PERSON,
    GROUPING_ROLE,
    PERIOD_ALL_TIME,
    PERIOD_CUSTOM,
    PERIOD_LAST_MONTH,
    PERIOD_THIS_MONTH,
    PERIOD_THIS_QUARTER,
    PERIOD_THIS_YEAR,
    TYPE_ALL,
    TYPE_FREELANCE,
    TYPE_INTERNAL,
} from './timeReportFormat';

import Button from 'CommonComponents/Button';
import SegmentedControl from 'CommonComponents/SegmentedControl';
import SelectInput from 'CommonComponents/SelectInput';

const GROUPING_OPTIONS = () => [
    { value: GROUPING_ROLE, label: $t('Role') },
    { value: GROUPING_PERSON, label: $t('Person') },
    { value: GROUPING_MONTH, label: $t('Month') },
];

const TYPE_OPTIONS = () => [
    { value: TYPE_ALL, label: $t('All') },
    { value: TYPE_INTERNAL, label: $t('Internal') },
    { value: TYPE_FREELANCE, label: $t('Freelance') },
];

const PERIOD_OPTIONS = () => [
    { value: PERIOD_ALL_TIME, label: $t('All time') },
    { value: PERIOD_THIS_MONTH, label: $t('This month') },
    { value: PERIOD_LAST_MONTH, label: $t('Last month') },
    { value: PERIOD_THIS_QUARTER, label: $t('This quarter') },
    { value: PERIOD_THIS_YEAR, label: $t('This year') },
    { value: PERIOD_CUSTOM, label: $t('Custom range') },
];

export default function TimeReportFilters({ filters, onChange, onExport }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4">
            <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-x-6 tw-gap-y-3">
                <div>
                    <label htmlFor="time_report_period" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                        {$t('Period')}
                    </label>
                    <SelectInput
                        id="time_report_period"
                        name="time_report_period"
                        value={filters.period}
                        onChange={(event) => onChange({ period: event.target.value })}
                    >
                        {PERIOD_OPTIONS().map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </SelectInput>
                </div>

                {filters.period === PERIOD_CUSTOM && (
                    <>
                        <div>
                            <label htmlFor="time_report_from" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                                {$t('From')}
                            </label>
                            <input
                                id="time_report_from"
                                type="date"
                                value={filters.from || ''}
                                max={filters.to || undefined}
                                onChange={(event) => onChange({ from: event.target.value })}
                                className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                            />
                        </div>
                        <div>
                            <label htmlFor="time_report_to" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                                {$t('To')}
                            </label>
                            <input
                                id="time_report_to"
                                type="date"
                                value={filters.to || ''}
                                min={filters.from || undefined}
                                onChange={(event) => onChange({ to: event.target.value })}
                                className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                            />
                        </div>
                    </>
                )}

                <div>
                    <span className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">{$t('Group by')}</span>
                    {/* `track` is the segmented control's hairline-bordered
                        variant with a solid blue active block. Not the `bc-seg`
                        block from Budget Changes, which exists only to carry a
                        count badge and whose stylesheet asks not to be given
                        another consumer. */}
                    <SegmentedControl variant="track" options={GROUPING_OPTIONS()} value={filters.grouping} onChange={(grouping) => onChange({ grouping })} />
                </div>

                <div>
                    <span className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">{$t('Type')}</span>
                    <SegmentedControl variant="track" options={TYPE_OPTIONS()} value={filters.type} onChange={(type) => onChange({ type })} />
                </div>
            </div>

            <Button variant="secondary" onClick={onExport}>
                {$t('Export')}
            </Button>
        </div>
    );
}
